import { FC } from 'react';

import { LoadingStatuses } from '@argenta/react-ui';
import { t } from '@lingui/macro';
import { Trans } from '@lingui/react';

import { ApplicationForm, ApplicationFormValues } from '../../components/Forms';
import { VacancyPageTemplate } from '../../components/VacancyPageTemplate';
import { usePostVacancyApplication } from '../../hooks/api/usePostVacancyApplication';
import { useI18nNavigate } from '../../hooks/navigation/useI18nNavigate';
import { VacanciesRoute } from '../../routers/AppRouter/routes';

import './SpontaneousApplication.styles.scss';

export const SpontaneousApplication: FC = () => {
  const { loadingStatus, postVacancyApplication, vacancyApplicationError } =
    usePostVacancyApplication({
      immediateExecute: false,
    });

  const navigate = useI18nNavigate();

  const handleOnVacancySubmit = async (formData: ApplicationFormValues): Promise<void> => {
    if (loadingStatus !== LoadingStatuses.LOADING) {
      try {
        await postVacancyApplication({
          requestData: {
            vacancyId: undefined,
            firstName: formData.firstName || '',
            lastName: formData.lastName || '',
            email: formData.email || '',
            linkedInProfile: formData.linkedIn || '',
            file: formData.cv,
            motivation: formData.motivation,
            cvAgreement: formData.cvAgreement,
          },
        });

        navigate(VacanciesRoute.APPLICATION_CONFIRMATION);
      } catch {
        // Error via prop from hook
      }
    }
  };

  return (
    <VacancyPageTemplate title={t({ id: 'vacancies.spontaneous.application.title' })} contentIsForm>
      <p className="argnt-vacancy-spontaneous-application__intro">
        <Trans id="vacancies.spontaneous.application.intro" components={{}} values={{}} />
      </p>
      <ApplicationForm
        onSubmit={handleOnVacancySubmit}
        errorMessage={vacancyApplicationError}
        isLoading={loadingStatus === LoadingStatuses.LOADING}
      />
    </VacancyPageTemplate>
  );
};
